import { groupApi } from './groupApi'

export const getEligibilityApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    getEligibility: builder.query({
      keepUnusedDataFor: 30,
      query: () => '/check',
      providesTags: ['eligibility'],
    }),
  }),
})

export const { useGetEligibilityQuery } = getEligibilityApiSlice
